import { Injectable} from '@angular/core';
import { ContractStepModel } from '../../../models/contract.model';
import { IContractDataModel, ITagData } from '../models/contract-internal-models';
import { TagsStylingMap, TagsStylinTextgMap } from '../models/contract-styling-consts';
import { ContractDataService } from './contract-data.service';
import { IMultiPaymentStateCS } from '../../../models/finance.model';
import { FileDataResponse } from '../../../services/api/documents-api.service';
import { MemberModel } from '../../../models/user.model';
import { ITaskTargetResponse } from '../../../models/task.model';

@Injectable({
    providedIn: 'root'
})
export class ContractTagsService {
  constructor (
    private contractDataService:ContractDataService
  ) {}
  updateStepTags(data:ContractStepModel,contractStatus:string,currentMember:MemberModel,contractGuid:string):ITagData|null {
    return this.getCompletedTag(data)||this.getActionRequieredMainTag(data,contractStatus,currentMember,contractGuid)||this.getDeadlineTag(data)
  }
  getDeadlineTag(stepData:ContractStepModel):ITagData|null {
    let months = new Map ([
      [0,'января'],
      [1,'февраля'],
      [2,'марта'],
      [3,'апреля'],
      [4,'мая'],
      [5,'июня'],
      [6,'июля'],
      [7,'августа'],
      [8,'сентября'],
      [9,'октября'],
      [10,'ноября'],
      [11,'декабря'],
    ])
    if (stepData.deadline_at) {
      let deadlineDate = new Date (stepData.deadline_at)
      return {
        label: deadlineDate.getDate() + ' '+ (months.get(deadlineDate.getMonth())||'') + ', 22:00',
        background:TagsStylingMap.get(stepData.target_type||'Base')?.background||'',
        color:TagsStylinTextgMap.get('deadline')?.color||'',
        icon:'time-line',
        iconColor:'base-icon'
      }
    }
    return null
  }
  getCompletedTag(stepData:ContractStepModel):ITagData|null {
    let completeStatus = new Map ([
      ['task','Завершена'],
      ['file','Подписан'],
      ['sub_contract','Исполнен'],
      ['credit_letter','Согласовано'],
      ['direct_payment','Оплачено'],
      ['payment','Оплачено'],
      ['multi_payment','Оплачено'],
    ])
    if (stepData.completed_at && stepData.target_type)  {
      return {
        label: completeStatus.get(stepData.target_type)||'',
        background:TagsStylingMap.get('Base')?.background||'',
        color:TagsStylinTextgMap.get('completed')?.color||'',
        additional_icon:'check-fill.svg',
        iconColor:'base-icon'
      }
    }
    return null
  }
  getActionRequieredMainTag(stepData:ContractStepModel,contractStatus:string,currentMember:MemberModel,contractGuid:string):ITagData|null {
    let targetData = this.contractDataService.getCachedStepTargetData(stepData)
    let needAction:boolean = false
    if (['open'].includes(contractStatus)) {
      return null
    }
    switch (stepData.target_type) {
      case 'task':
        targetData = targetData as ITaskTargetResponse  
        needAction = this.getActionRequieredTask(stepData,contractStatus,contractGuid)
      break;
      case 'file':
        targetData = targetData as FileDataResponse  
        needAction = this.getActionRequieredFile(currentMember,targetData)
      break;
      case 'credit_letter':
        needAction = this.getActionRequieredCrediLetter(stepData,currentMember)
      break;
      case 'multi_payment':
        targetData = targetData as IMultiPaymentStateCS  
        needAction = this.getActionRequieredMultiPayment(targetData)
      break;
    }
    if (needAction)  {
      return {
        label: 'Требуется действие',
        background:TagsStylingMap.get(stepData.target_type||'Base')?.background||'',
        color:TagsStylinTextgMap.get('action')?.color||'',
        icon:'error-warning-line',
        iconColor:'accent-icon'
      }
    }
    return null
  }
  getActionRequieredCrediLetter (stepData:ContractStepModel, currentMember:MemberModel):boolean {
    let isStepSigned = false
    let signatories =stepData.target?.payer_project?.members?.signatories
    stepData.target?.payer_private?.member ? signatories = [{
        member: stepData.target.payer_private.member,
        can_verify: true,
        verified_at: stepData.target.payer_private.verified_at,
    }] : null;
    let signedMembers = stepData.members_signed_step?.map(el=>el.member_guid)
    signatories? isStepSigned = signatories.filter(el =>signedMembers?.includes(el.member.guid)).length===0 :null
    return isStepSigned
  }
  getActionRequieredTask (stepData:ContractStepModel,contractStatus:string,contractGuid:string):boolean {
    let contractData = this.contractDataService.ContractDataCachedByGuid.get(contractGuid)
    let allSigners = contractData.allSignatoriesInContract
    return (contractStatus === 'verified' &&
        !stepData?.completed_at &&
        allSigners.length !== stepData?.members_signed_step?.length &&
        stepData?.target && stepData?.target.is_verified) || false
  }
  getActionRequieredFile (currentMember:MemberModel,targetData:FileDataResponse):boolean {
    return targetData?.signers?.filter(el=>el.sign === false).length !==0
  }
  getActionRequieredMultiPayment (targetData:IMultiPaymentStateCS):boolean {
    return targetData.isMemberSign === false || targetData.isSignPaymentsALot === true
  }
}